module.exports = "<div class=\"wrapper\">\n  <div>\n    <router-outlet></router-outlet>\n    <div *ngIf=\"isMaps('maps')\">\n    </div>\n  </div>\n</div>\n"